<template>
  <div>
    <section class="main-content">

        <!-- <div class="inner-banner">
            <div class="container">

                <div class="articles-box catalog-box">
                    <figure class="pic articles-pic fitimg mb-0">
                        <img class="img-fluid" src="build/images/aboutus-1.png" />
                    </figure>
                    <div class="text text-center">
                        <h4 class="title">求婚/迎賓</h4>
                        <p class="txt">"Here comes the bride." The processional is the quintessential moment of your wedding day. Walking down the aisle, locking eyes with your groom and seeing the smiles (and maybe some tears) of your family and friends. Of course,
                            you need the perfect song to walk down the aisle to. Whether you're a fan of the classics like Pachelbel and Hans Zimmer or prefer to surprise guests with a string rendition of Chasing Cars, we have 100 wedding processional
                            songs for you to choose from. Once you find the perfect song to walk down the aisle to, be sure to watch the video and read the lyrics to envision your day. With your ideal love song picked out, browse our ceremony programs
                            so guests can relish in the details as they wait for the music to start.</p>
                    </div>
                </div>

            </div>
        </div> -->
        <div class="main-block main-block-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-articles bck-views">
                            <h2 class="title">
                                <span>挑選婚禮歌曲的重要原則</span>
                                <!-- <span class="sub-title">by Carrie Underwood</span> -->
                            </h2>
                            <article class="article-editor">

                              <div class="row songpic-list">
                                <div class="col-sm-4">
                                  <div class="articles-box songpic-box">
                                    <h5 class="title">
                                      <span class="sort-no text-primary">1.</span>
                                      清楚了解挑選歌曲適用於婚禮的原因
                                    </h5>
                                    <p class="txt">
                                      從歌詞含意和歌曲旋律，判斷這首歌為何適用於婚禮。
                                      如：表達愛意、寄託承諾、期待幸福、祝福未來…….
                                    </p>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="articles-box songpic-box">
                                    <h5 class="title">
                                      <span class="sort-no text-primary">2.</span>
                                      充分掌握挑選歌曲適用於婚禮的時機
                                    </h5>
                                    <p class="txt">
                                      求婚/迎賓、進場(一次、二次) 、愛情回顧影片、婚宴、送客/蜜月，各時機可能有不同的適用條件，根據歌詞、歌曲特色大致判斷適用性。
                                    </p>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="articles-box songpic-box">
                                    <h5 class="title">
                                      <span class="sort-no text-primary">3.</span>
                                      追求挑選歌曲的品質而不在於數目
                                    </h5>
                                    <p class="txt">
                                      婚禮過程有各個不同的流程，因此對歌曲要表達的訊息和情緒有不同的要求，很多時候，好好挑選一首婚禮歌曲在適當的時機播放，比放很多首更令人難忘。
                                    </p>
                                  </div>
                                </div>
                              </div>

                            </article>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="bck-index bck-articles">
                            <h3 class="title sr-only"><span>挑歌秘訣</span></h3>
                            <div class="articles-items">

                              <ul class="songpic-imglist list-inline">
                                <li class="list-inline-item">
                                  <figure class="pic articles-pic">
                                      <!-- <img class="img-fluid" src="/static/images/catalog-1.png" /> -->
                                      <img class="" src="/static/images/songsPick-1.png" />
                                  </figure>
                                  <div class="text text-center">
                                      <h5 class="title">婚曲歌詞</h5>
                                      <article class="article-editor">
                                        <p class="txt">歌詞最能代表新人的心意，
                                            <br />寄予對方或告知親朋好友，
                                            <br />新人對婚姻的承諾與期待。</p>
                                      </article>
                                  </div>
                                </li>
                                <li class="list-inline-item">
                                  <figure class="pic articles-pic">
                                      <img class="" src="/static/images/songsPick-2.png" />
                                  </figure>
                                  <div class="text text-center">
                                      <h5 class="title">歌曲旋律</h5>
                                      <article class="article-editor">
                                        <p class="txt">表達新人希望在婚禮時傳達的情緒，
                                            <br />緩慢的旋律能娓娓訴說深情，
                                            <br />而較快的旋律可以呈現歡樂的心情。</p>
                                      </article>
                                  </div>
                                </li>
                                <li class="list-inline-item">
                                  <figure class="pic articles-pic">
                                      <img class="" src="/static/images/songsPick-3.png" />
                                  </figure>
                                  <div class="text text-center">
                                      <h5 class="title">歌曲節奏</h5>
                                      <article class="article-editor">
                                        <p class="txt">要考量適合的用法和時機，
                                            <br />和婚禮儀式或節目表演的畫面配合，
                                            <br />讓婚禮進行的每個階段都扣人心弦。</p>
                                      </article>
                                  </div>
                                </li>
                                <li class="list-inline-item">
                                  <figure class="pic articles-pic">
                                      <img class="" src="/static/images/songsPick-4.png" />
                                  </figure>
                                  <div class="text text-center">
                                      <h5 class="title">播放曲數</h5>
                                      <article class="article-editor">
                                        <p class="txt">婚禮歌曲播放曲數有多種選擇，
                                            <br />適當搭配婚禮進行各階段，
                                            <br />完整呈現整個婚禮要傳達的美意。</p>
                                      </article>
                                  </div>
                                </li>
                              </ul>
                                <!--
                                <div class="row">
                                    <div class="col-md-4 col-sm-6">
                                        <div class="articles-box catalog-box">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" src="/static/images/catalog-1.png" />
                                                </figure>
                                                <div class="text text-center">
                                                    <h5 class="title">婚曲歌詞</h5>
                                                    <article class="article-editor">
                                                      <p class="txt">歌詞最能代表新人的心意，
                                                          <br />寄予對方或告知親朋好友，
                                                          <br />新人對婚姻的承諾與期待。</p>
                                                    </article>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-6">
                                        <div class="articles-box catalog-box">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" src="/static/images/catalog-2.png" />
                                                </figure>
                                                <div class="text text-center">
                                                    <h5 class="title">歌曲旋律</h5>
                                                    <article class="article-editor">
                                                      <p class="txt">表達新人希望在婚禮時傳達的情緒，
                                                          <br />緩慢的旋律能娓娓訴說深情，
                                                          <br />而較快的旋律可以呈現歡樂的心情。</p>
                                                    </article>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-6">
                                        <div class="articles-box catalog-box">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" src="/static/images/catalog-3.png" />
                                                </figure>
                                                <div class="text text-center">
                                                    <h5 class="title">歌曲節奏</h5>
                                                    <article class="article-editor">
                                                      <p class="txt">要考量適合的用法和時機，
                                                          <br />和婚禮儀式或節目表演的畫面配合，
                                                          <br />讓婚禮進行的每個階段都扣人心弦。</p>
                                                    </article>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-6">
                                        <div class="articles-box catalog-box">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" src="/static/images/catalog-4.png" />
                                                </figure>
                                                <div class="text text-center">
                                                    <h5 class="title">播放曲數</h5>
                                                    <article class="article-editor">
                                                      <p class="txt">婚禮歌曲播放曲數有多種選擇，
                                                          <br />適當搭配婚禮進行各階段，
                                                          <br />完整呈現整個婚禮要傳達的美意。</p>
                                                    </article>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                -->
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>


        </section>
  </div>
</template>

<script>
export default {
  name: 'songspick',
  data () {
    return {
      category: []
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// SongsPick.vue?fa201960